module.exports = __webpack_public_path__ + "static/media/CSS3.6457bd26.png";